export const MIN_DELAY = 10000; // 10 seconds (in ms)
export const EMAIL_PLACEHOLDER = 'example@domain.com';
